// import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  getPayStatus: ({commit}, data) => {
    return new Promise(resolve => {
      pointsMailApi.getPayStatus(data)
        .then(result => {
          resolve(result)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-cashier/store/actions.js